export const paymentLinksRouteNames = {
  listPaymentLinks: 'payment-links',
  paymentLinksEditor: 'payment-links-editor',
}
